import { getClassFunction } from '@helpers/functions';

const getClass = getClassFunction('kf-m-radio-group');

window.KFRadioGroup = window.KFRadioGroup || {
  elements: document.querySelectorAll(getClass(undefined, { checkAttached: true })),
  init() {
    this.elements = document.querySelectorAll<HTMLElement>(getClass(undefined, { checkAttached: true }));
    [].forEach.call(this.elements, (el) => this.setupRadioGroup(el));
  },
  setupRadioGroup(el: HTMLElement) {
    if (!el) return;
    el.dataset.eventAttached = 'true';

    const radios = el.querySelectorAll("input[type='radio']");

    [].forEach.call(radios, (radio: HTMLInputElement) => {
      const checked = radio.checked;
      const checkMark = radio.nextElementSibling as HTMLElement;

      checkMark?.setAttribute('aria-checked', checked ? 'true' : 'false');
      checkMark.addEventListener('keydown', (e: KeyboardEvent) => {
        if (e.key === 'Enter') {
          radio.click();
        }
      });
      radio.addEventListener('change', () => {
        [].forEach.call(radios, (groupRadio: HTMLInputElement) => {
          const groupCheckMark = groupRadio.nextElementSibling as HTMLElement;

          groupCheckMark?.setAttribute('aria-checked', groupRadio.checked ? 'true' : 'false');
        });
        el.dispatchEvent(
          new CustomEvent('radio-change', {
            detail: {
              value: radio.value,
            },
          })
        );
      });
    });
  },
};

window.KFRadioGroup.init();

export {};
